import { useRecoilValue } from 'recoil';

import { useUserPreferences } from 'lib/hooks/queries/user/useUserPreferences';

import { currentPractice } from 'components/practice/practiceState';

const DEFAULT_TIMEZONE = 'America/New_York';

const useTimezone = ({ enabled = true } = {}) => {
  const practice = useRecoilValue(currentPractice);

  const { data } = useUserPreferences({
    params: { name: 'user_calendar' },
    dependencies: ['user_calendar'],
    options: { enabled }
  });

  const userTimezone = data?.preferences?.value?.calendarTimezone?.value;
  const practiceTimezone = practice?.timezone;

  return userTimezone || practiceTimezone || DEFAULT_TIMEZONE;
};

export default useTimezone;
